import { styled, Box } from "@mui/material";

export const EyeContainer = styled(Box)(() => ({
  transform: "translate(16px, 4px)",
}));
